/* eslint-disable react/jsx-filename-extension */
import { useMutation, useQuery } from '@apollo/client';
import React from 'react';

import {
  GET_TASK_VIEW,
  UPDATE_TASK_VIEW
} from '@nile/graphql/src/Mutation/task';
import { useIntl } from 'react-intl';
import { EventEmitter, getTranslatedText } from '@nile/components/src';
import { TaskViewModal } from './TaskViewModal';

export function EditTaskView({ onClose, id }) {
  const { data: taskView, loading } = useQuery(GET_TASK_VIEW, {
    variables: {
      id
    },
    fetchPolicy: 'network-only'
  });

  const [updateTaskView] = useMutation(UPDATE_TASK_VIEW);

  const intl = useIntl();

  if (loading) return null;

  return (
    <TaskViewModal
      isOpen
      title={getTranslatedText(intl, 'task.view.edit.header')}
      actions={{
        back: onClose,
        primaryAction: (input) => {
          return updateTaskView({
            variables: {
              id: taskView.getTaskView.id,
              input: input
            }
          }).then(() => {
            EventEmitter.dispatch('refreshTaskViewCount');
          });
        },
        savePersonalization: () => {}
      }}
      taskViewName={taskView.getTaskView.name}
      isSharedChecked={taskView.getTaskView.shared}
      viewCondition={taskView.getTaskView.viewCondition}
    />
  );
}
